import { createContext } from "react"
import { FornecedorInicial, FornecedorModel } from "../models/fornecedorModel"
import { DadosFornecedorActionModel } from "./dadosFornecedorActions"

type DadosFornecedorContextProps = {
    fornecedor: FornecedorModel
    dispatch: React.Dispatch<DadosFornecedorActionModel>
    salvar: (novaSenha?: string) => Promise<void>
    carregando: boolean
    erroCarregamento: string | null
}

const initialContextValue: DadosFornecedorContextProps = {
    fornecedor: FornecedorInicial,
    dispatch: () => {},
    salvar: async () => {},
    carregando: false,
    erroCarregamento: null,
}

export const DadosFornecedorContext = createContext<DadosFornecedorContextProps>(initialContextValue)
